import React from 'react';
import styled from 'styled-components';

export const VolumeSection = styled.div`
    position: absolute;
    ${props => {
        const layout = props.layout || {};
        let styles = '';
        if (layout.top !== undefined) styles += `top: ${typeof layout.top === 'string' ? layout.top : `${layout.top}px`}; `;
        if (layout.right !== undefined) styles += `right: ${typeof layout.right === 'string' ? layout.right : `${layout.right}px`}; `;
        if (layout.bottom !== undefined) styles += `bottom: ${typeof layout.bottom === 'string' ? layout.bottom : `${layout.bottom}px`}; `;
        if (layout.left !== undefined) styles += `left: ${typeof layout.left === 'string' ? layout.left : `${layout.left}px`}; `;
        if (layout.width !== undefined) styles += `width: ${typeof layout.width === 'string' ? layout.width : `${layout.width}px`}; `;
        if (layout.height !== undefined) styles += `height: ${typeof layout.height === 'string' ? layout.height : `${layout.height}px`}; `;
        if (layout.transform) styles += `transform: ${layout.transform}; `;
        return styles;
    }}
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0;
    justify-content: flex-end;
    z-index: 10;
`;

export const VolumeSlider = styled.div`
    position: relative;
    width: 35px;
    height: 100%;
    min-height: 70px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    gap: 2px;
    cursor: pointer;
    padding: 4px 0;

    @media (max-width: 768px) {
        min-height: 60px;
        width: 30px;
    }
`;

export const VolumeLines = styled.div`
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    width: 100%;
    height: 80%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    pointer-events: none;
    z-index: 1;
    padding-bottom: 10px;
    padding-top: 10px;
`;

export const VolumeLine = styled.div`
    width: ${props => props.width}px;
    height: 2px;
    background: rgba(244, 212, 163, 0.2);
    border-radius: 1px;
`;

export const VolumeTrack = styled.div`
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 6px;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 3px;
    border: 1px solid rgba(244, 212, 163, 0.2);
    box-shadow: inset 2px 0 4px rgba(0, 0, 0, 0.5);
    cursor: pointer;
    z-index: 2;
`;

export const VolumeHandle = styled.div`
    position: absolute;
    left: 50%;
    bottom: ${props => props.value || 100}%;
    transform: translate(-50%, 50%);
    width: 24px;
    height: 8px;
    background: linear-gradient(180deg, #4a4a4a 0%, #2a2a2a 100%);
    border: 2px solid rgba(244, 212, 163, 0.5);
    border-radius: 4px;
    box-shadow: 
        0 2px 6px rgba(0, 0, 0, 0.5),
        inset 0 1px 2px rgba(0, 0, 0, 0.3);
    cursor: grab;
    transition: all 0.2s ease;
    z-index: 3;

    &:hover {
        border-color: rgba(244, 212, 163, 0.8);
        box-shadow: 
            0 2px 8px rgba(244, 212, 163, 0.4),
            inset 0 1px 2px rgba(0, 0, 0, 0.3);
        transform: translate(-50%, 50%) scale(1.1);
    }

    &:active {
        cursor: grabbing;
        transform: translate(-50%, 50%) scale(0.95);
    }
`;

const VolumeSliderComponent = ({ value, onMouseDown }) => {
    return (
        <VolumeSlider 
            data-volume-slider
            onMouseDown={onMouseDown}
        >
            <VolumeLines>
                {Array.from({ length: 10 }, (_, i) => {
                    // 从下到上，横线逐渐变宽
                    // 最下面少两条，所以从第3条开始显示（i+2）
                    const lineIndex = 9 - i; // 反转索引，让底部是第一条
                    const maxWidth = 30; // 最长横线宽度
                    const minWidth = maxWidth / 2; // 最短横线宽度（最长的一半）
                    // 从第3条开始，所以宽度计算从 minWidth 开始
                    const lineWidth = minWidth + (lineIndex / 9) * (maxWidth - minWidth);
                    
                    return (
                        <VolumeLine
                            key={i}
                            width={lineWidth}
                        />
                    );
                })}
            </VolumeLines>
            <VolumeTrack />
            <VolumeHandle value={value} />
        </VolumeSlider>
    );
};

export default VolumeSliderComponent;

